









































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import InteractiveData from '@/components/question/interactive_data/InteractiveData.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import ResetExamEditor from '@/components/ResetExamEditor.vue';
import FileBoxesEditor from '@/components/FileBoxesEditor.vue';

export default Vue.extend({
  components: {
    Content,
    InteractiveData,
    pxCard,
    SquareEditOutlineIcon,
    ArrowRightIcon,
    Loading,
    ResetExamEditor,
    FileBoxesEditor,
  },

  data() {
    return {
      loaded: true,
    };
  },

  computed: {
    ...mapGetters({
      exam: 'currentExam',
      fileBoxes: 'fileBoxes',
      questionReplyStats: 'questionReplyStats',
    }),
  },

  async created() {
    let examId = parseInt(this.$route.params.examId);
    if (!examId) examId = 22; //TODO landing page
    this.loaded = false;
    await this.$store.dispatch('PULL_EXAM', examId);
    this.loaded = true;

    const questionIds = (this.exam.questions || []).map(
      (question: any) => question.id,
    );
    this.$store.dispatch('PULL_EXAM_QUESTION_REPLY_STATS', { questionIds });
  },

  methods: {
    replyStatsFor(questionId: number) {
      return this.questionReplyStats[questionId] || null;
    },
    hasReplyStats(questionId: number) {
      return Array.isArray(this.questionReplyStats[questionId]);
    },
  },
});
